// biome-ignore lint/style/useNodejsImportProtocol: buffer is not available globally in RN
import { Buffer } from "buffer";
import { hubAxios } from "@helpers/lib/axios";
import { HUB_ENDPOINTS } from "@memorang/constants/urls";

export type CmeCertificate = {
	recipientName: string;
	activityTitle: string;
	startDate: string;
	endDate: string;
	credits: string;
	companyName: string;
	toEmail: string;
	creditName: string;
	infoText: string;
	companyAddress: string;
	primaryColor: string;
	logoUrl: string;
};

export const generateCmeCertificatePdfBase64 = async (data: CmeCertificate) => {
	const response = await hubAxios.post<ArrayBuffer>(
		HUB_ENDPOINTS.GENERATE_CERTIFICATE,
		data,
		{ responseType: "arraybuffer" },
	);

	return Buffer.from(response.data).toString("base64");
};

export const sendCmeCertificateByEmail = async (data: CmeCertificate) => {
	const { data: result } = await hubAxios.post(
		HUB_ENDPOINTS.SEND_CERTIFICATE,
		data,
	);

	return result;
};
